import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getUserLocation } from '../domain/location/api';
import type { UserLocation } from '../domain/location/api';

export const USER_LOCATION_QUERY_KEY = 'userLocation';

type Selector<SelectorReturnType> = (currentUser: UserLocation) => SelectorReturnType;

export const useUserLocation = <SelectorReturnType = UserLocation>(
  selector?: Selector<SelectorReturnType>,
): UseQueryResult<SelectorReturnType, Error> => {
  return useQuery(USER_LOCATION_QUERY_KEY, getUserLocation, {
    select: selector,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
